"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubscription = void 0;
const react_1 = require("react");
function useSubscription(observable, observer, deps = [observable]) {
    react_1.useEffect(() => {
        if (typeof observer === "function") {
            const s = observable.subscribe(observer);
            return () => {
                s.unsubscribe();
            };
        }
        else {
            const s = observable.subscribe(observer);
            return () => {
                s.unsubscribe();
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
exports.useSubscription = useSubscription;
